/**
 * 数据集相关类型定义
 */

/**
 * 数据集状态枚举
 */
export enum DatasetStatus {
  /** 禁用 */
  DISABLED = 0,
  /** 启用 */
  ENABLED = 1,
}

/**
 * 数据集基础信息
 */
export interface Dataset {
  /** 数据集ID */
  id: string
  /** 数据集描述 */
  desc: string
  /** 数据集图标URL */
  icon: string
  /** 数据集名称 */
  name: string
  /** 数据集状态 */
  status: DatasetStatus
  /** 文件数量 */
  filesNum: string
  /** 更新时间 */
  updateTime: string
  /** 更新者 */
  updater: string
  /** 创建者 */
  creator: string
  /** 创建时间 */
  createTime: string
}

/**
 * 获取数据集列表请求参数
 */
export interface GetDatasetListRequest {
  /** 知识库ID */
  knowledgeBaseId: string
  /** 搜索关键词 */
  search?: string
  /** 数据集状态 */
  status?: DatasetStatus
}

/**
 * 数据集列表响应
 */
export interface DatasetListResponse {
  /** 数据集列表 */
  datasets: Dataset[]
}
